import React from 'react';
import Loader from '../common/Loader';
const GoogleMapsModal = (props) => {
    const [loadingIframe, setLoadingIframe] = React.useState(true);
    const loadCallback = () => { setLoadingIframe(false); }
    const closeModal = e => {
        e.preventDefault();
        props.onClose();
    }

    React.useEffect(() => {
        setLoadingIframe(true);
    }, [props.open])
    return (
    props.open ? 
    <div onClick={closeModal} className="google-maps-modal-container">
        {loadingIframe&&<div className="google-maps-modal-loader-container"><Loader title="Loading Google Maps..." /></div>}
        <iframe
            title="google-maps-preview"
            id="google-maps-iframe" 
            onLoad={loadCallback} 
            src={`https://maps.google.com/?q=${props.lat},${props.lon}&output=embed`} 
            frameBorder="0" 
            style={{height: "90vh", width: "80vw"}}
            className={`${loadingIframe&&"d-none"} z-75`}
        ></iframe>
    </div>
    : null);
}

export default GoogleMapsModal;